import React, {useEffect} from "react";
import PicData from "./entity/PicData";

interface MicroFrontendProps {
  name: string;
  cloudFrontUrl: any;
  history?: any;
  data?: PicData;
}

const MicroFrontend = ({name, cloudFrontUrl, history, data}: MicroFrontendProps) => {
  const containerId = `${name}-container`;
  const scriptId = `micro-frontend-script-${name}`;

  useEffect(() => {
    if (document.getElementById(scriptId)) {
      sendRenderModuleNotification(name, containerId, data, history);
      return () => {
        sendUnmountModuleNotification(name, containerId);
      };
    }

    fetch(`${cloudFrontUrl}/asset-manifest.json`, {credentials: 'include'})
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error(`Assets can not be fetched, response: ${JSON.stringify(res)}`);
        }
      })
      .then((manifest) => {
        const script = document.createElement("script");
        script.id = scriptId;
        script.crossOrigin = "use-credentials";
        script.src = `${cloudFrontUrl}${manifest.files["main.js"]}`;
        script.onload = () => {
          sendRenderModuleNotification(name, containerId, data, history);
        };
        document.head.appendChild(script);
      })
      .catch((error) => {
        console.log(error)
      });

    return () => {
      sendUnmountModuleNotification(name, containerId);
    };
  }, []);

  useEffect(() => {
    sendUpdatePropNotification(data.languageCode, "changeLanguage");
  },[data]);

  return <main id={containerId}/>;
};

/**
 * Sends the notification when prop is updated.
 */
function sendUpdatePropNotification(prop: any, eventName: string) {

  const eventData = { detail: prop };

  const updatePropEvent = new CustomEvent(eventName, eventData);
  window.dispatchEvent(updatePropEvent);
}

/**
 * Sends the notification after the JS is loaded successfully to start the module rendering.
 */
function sendRenderModuleNotification(moduleName: string,
                                      containerId: string,
                                      data?: PicData,
                                      history?: any) {
  const eventName = `render${moduleName}`;
  const eventData = { containerId, history, data };

  // Create and send JS load notification for load event
  const jsLoadNotificationEvent = new CustomEvent(eventName, { detail: eventData });
  window.dispatchEvent(jsLoadNotificationEvent);
}

/**
 * Sends an event when the component is being unmounted to start the clean up process
 * on module.
 */
function sendUnmountModuleNotification(moduleName: string,
                                       containerId: string) {
  const eventName = `unmount${moduleName}`;
  const eventData = { containerId };

  // Create and send unmount notification event
  const moduleUnmountNotificationEvent = new CustomEvent(eventName, { detail: eventData });
  window.dispatchEvent(moduleUnmountNotificationEvent);
}

MicroFrontend.defaultProps = {
  document,
  window,
};

export default MicroFrontend;
